<div class="content-wrapper">
    <!-- Main content -->
    <section class="content">
        <!-- Default box -->
        <div class="box">
            <img src="/assets/img/dashboard.JPG" style="width: 100%; height: 600px;" alt="dashboard image"/>
        </div>
    </section>
</div>